<template>
  <header class="d-flex flex-wrap justify-space-between">
    <div class="d-flex flex-column">
      <RouterLink
        v-if="showBack && backTo"
        :to="backTo"
        class="text-sm text-gray-500 hover:underline hover:text-gray-700 inline-block mb-1"
      >
        ← Back to {{ backToLabel || "Customers" }}
      </RouterLink>
      <h1 :class="compact ? 'text-h5' : 'text-h4'" class="font-weight-bold mb-6">
        {{ title }}
      </h1>
    </div>

    <!-- Slot for action buttons (Save, Create, etc.) -->
    <div class="flex gap-2 mb-4">
      <slot />
    </div>
  </header>
</template>

<script setup lang="ts">
defineProps<{
  title: string;
  backTo?: string;
  backToLabel?: string;
  showBack?: boolean;
  /** Smaller title and spacing for dense pages (e.g. customer profile). */
  compact?: boolean;
}>();
</script>
